import { createSelector } from 'reselect'
import { each } from 'lodash'

const todosSelector = state => state.account.entities.todos;

export const getAccountTodos = (state) => {
	let todosObject = {}

	return each(state.account.entities.todos, todo => {
		if(todo.account_id === state.account.currentAccountId){
			todosObject[todo.id] = todo;
		}
	});
}



// WEBPACK FOOTER //
// ./src/state/selectors/todoSelector.jsx